import {
  DSButton,
  DSCardWrapper,
} from "@components/design-system/molecules";
import {
  faCheckCircle,
  faInfoCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VerifyStep = ({
  validationCode,
  onDone,
  verificationProgress,
  phoneNumber,
}) => {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-primary mb-2">
          Verify Your Phone
        </h3>
      </div>

      {validationCode && (
        <div className="text-center">
          <p className="text-sm text-secondary mb-2">
            {phoneNumber} will receive a call shortly. Enter this code
            when prompted:
          </p>
          <p className="text-4xl font-bold text-brand tracking-widest">
            {validationCode}
          </p>
        </div>
      )}

      {verificationProgress && (
        <DSCardWrapper variant="info">
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="text-brand"
            />
            <p className="text-sm text-brand">
              {verificationProgress}
            </p>
          </div>
        </DSCardWrapper>
      )}

      <DSCardWrapper variant="success">
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="text-success"
          />
          <p className="text-sm text-success">
            Please only click 'done' after you have hung up the call.
          </p>
        </div>
      </DSCardWrapper>

      <div className="flex justify-center space-x-2">
        <DSButton onClick={onDone}>Done</DSButton>
      </div>
    </div>
  );
};

export default VerifyStep;
